import { j as e, I as r, d as t } from "./IconTemplate-c24f5ddb.mjs";
import "react";
const o = (a) => /* @__PURE__ */ e(r, { ...a, name: a.name || "Check", viewBox: "0 0 1024 1024", children: /* @__PURE__ */ e(
  "path",
  {
    d: "M998.4 245.03c-219.43 153.6-398.63 332.8-552.23 552.23-40.23 58.51-128 54.86-164.57-3.66-69.49-106.06-149.94-186.51-256-256-51.2-32.91-18.29-113.37 40.23-98.74 117.03 21.94 208.46 69.49 292.57 146.28 157.26-190.17 358.4-340.11 588.8-435.2 62.17-25.6 106.06 58.51 51.2 95.09",
    fill: "currentColor",
    fillOpacity: "0.9"
  }
) });
o.defaultProps = t;
export {
  o as default
};
